import { render, staticRenderFns } from "./PageEditor.vue?vue&type=template&id=3dc57669"
import script from "./PageEditor.vue?vue&type=script&lang=js"
export * from "./PageEditor.vue?vue&type=script&lang=js"
import style0 from "./PageEditor.vue?vue&type=style&index=0&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports